module.exports = __webpack_public_path__ + "assets/media/card-img-campaign.5e3045f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-campaign.jpg
// module id = 3248
// module chunks = 0